export const earn = {
  jdzb: "简单赚币",
  jryd: "金融有道，携手共进",
  jrbk: "加入 Biking简单赚币，创新无限让您的数字资产获得最大收益",
  zbz: "赚币中",
  ljsy: "累计收益",
  zrsy: "昨日收益",
  hq: "活期",
  dq: "定期",
  cknh: "参考年化",
  sqjd: "申购进度",
  sg: "申购",
  qbcp: "全部产品",
  cz: "重置",
  qx: "期限",
  question1: "1. 什么是赚币 ？",
  question1_text: "赚币是BIKING打造的帮助用户发现多种持币产品机会的一站式服务平台。目前推出简单赚币即余币宝（随存随取），后续将上线更多产品，为用户提供丰富的产品选择。",
  question2: "2. 什么是参考年化？",
  question2_text: "赚币收益目前为存入代币的利息。参考年化是存入代币的利息年化，例如一产品首1000U按12%参考年化，超过首1000U按2%参考年化，总参考利息年化为14%。",
  question3: "3. 什么时间开始起息/结息？",
  question3_text: "申购不同的产品时，开始起息/结息的时间可能不同。以目前USDT的日计息的简单赚币为例，购买USDT活期产品的次日凌晨2点起息（UTC+8）, 起息时间 T+1（即购买时间T+2）的凌晨5点（UTC+8）发放次日结算前一日的利息；",
  question4: "4. 什么是剩余可投？",
  question4_text: "剩余可投是您还能申购该理财产品的数量<br/>剩余可投=总产品可购额度-您已申购的数量",
  xzmbfs: "选择充币/买币方式",
  nhsyl: "年化收益率及期限：",
  sl: "数量",
  qitou: "起投",
  max: "最大",
  kzcsl: "此为资金账户可转出数量",
  sykt: "剩余可投",
  syktsl: "剩余可投是您还能申购的数量",
  syktsx: "剩余可投=总产品可购额度-您已申购的数量（不大于个人可投上限{amount}{coin}）",
  jlgz: "奖励规则",
  jd1: "阶梯1:首{amount}{coin}",
  ptjl: "平台奖励",
  jd2: "阶梯2:大于首{amount}{coin}",
  jd22:"阶梯",
  jd3: "阶梯3:大于{amount}{coin}",
  grsgsx: "个人申购上限为{amount}{coin}",
  gz: "规则",
  sgsj: "申购时间",
  xianzai: "现在",
  qxsj: "起息时间",
  lxrz: "利息入账",
  c2c: "C2C买币",
  lhxz: "灵活选择，价格更优",
  lcjd: "流程简单，快速成交",
  crszhb: "从钱包或交易所存入数字货币",
  zcsl: "资产数量",
  dzsy: "到账收益",
  lcxx: "理财信息",
  zt: "状态",
  sh: "赎回",
  sgje: "申购金额",
  sgzj: "申购资金的首{amount}{coin}可赚取{value}%奖励年化",
  dyklqje: "大于{amount}{coin}的可赚取{value}%奖励年化",
  grsged: "个人申购额度为{amount}～{amount2}{coin}",
  shsl: "赎回数量",
  srshsl: "输入赎回数量",
  ksh: "可赎回：",
  haode: "好的",
  sgcg: "申购成功",
  shcg: "赎回成功",
  zcsg: "再次申购",
  sjdzsl: "实际到账数量",
  shsj: "赎回时间",
  jssj: "结算时间",
  yjsdd: "已结算订单",
  jyjl: "交易记录",
  hqjdzb: "活期简单赚币",
  sy: "收益",
  wwc: "未完成",
  xmlx: "项目类型",
  hqjdzbcp: "活期简单赚币,是Biking打造的安全理财产品,支持24小时随存随取,按小时计息",
  nh: "年化",
  zhzchz: "账户资产互转，简洁快速",
  qsrsl: "请输入数量",
  yjssymx: "已结算收益明细",
  mx: "明细",
  qwsmrz: "前往实名认证",
  jxwcsmrz: "1.本次活动仅限完成实名认证的用户，每位用户仅有一次参与该活动机会",
  dqcked: "2.每位用户定期存款额度为{min}~{max}{coin}，到期系统自动赎回至账户",
  cpbntjsh: "3.该产品不能提前赎回",
  anzh: "4.产品认购完，总池为0，按键置灰",
  smrzyh: "活动仅限完成实名认证的用户,",
  jxcjyc: "每位符合条件的用户仅限参与一次",
  ygsy: "预估收益",
  scqx: "锁仓期限",
  qixian: "第{min}天 (共{max}天)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/zh.js